module.exports = __webpack_public_path__ + "07d9c59b86b4ef309fe399d9e58a9178.png";